import {CREATE_ORDER_BY_CONSULT_PACKAGE} from '../constants/order';

export function createOrderByConsultPackage(packageId, codeText) {
  return ({
    type: CREATE_ORDER_BY_CONSULT_PACKAGE,
    api: true,
    auth: true,
    payload: {
      method: 'POST',
      url: '/transactions/orders',
      data: {packageId, codeText}
    }
  });
}
